<template>
  <modal-template size="small"
                  @close="$emit('closeAdvise3ds')">
    <b-row>
      <b-col cols="12">
        <b-img-lazy :src="require('@/assets/images/ic-info.png')"
                    alt="Modal error"
                    fluid />
      </b-col>
      <b-col cols="12" class="mB15">
        <p class="mT15">{{ $t('advise.alSuperarElImporteDeLaOperacion3ds')}}</p>
        <br>
        <b-button class="btn transparent"
                @click="$emit('aceeptPayment')">{{ $t('modalReport.continuar') }}</b-button>
        </b-col>
    </b-row>
  </modal-template>
</template>

<script>
import ModalTemplate from '@/components/modal-template/ModalTemplate.vue'

export default {
  components: {
    ModalTemplate
  }
}
</script>
